// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"jU","header":"jV","title":"jW","subheader":"jX","formWrapper":"jY"};